var render = function () {
  var _vm$category, _vm$category2, _vm$category3, _vm$category4, _vm$me;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('category-list', {
    attrs: {
      "return-object": ""
    },
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  })], 1), _c('v-col', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("쿠폰 교환소")])]), _c('div', {
    staticClass: "font-size-14 font-size-md-16 grey--text text--garken-3 mt-md-n20px mb-20px mb-md-30px"
  }, [_c('p', [_vm._v("* 본인인증을 진행한 후 30분 동안 구매 가능합니다.")]), _c('p', [_vm._v("* 구매전 본인인증을 진행해주세요")])]), ((_vm$category = _vm.category) === null || _vm$category === void 0 ? void 0 : _vm$category.code) === 'department' || !((_vm$category2 = _vm.category) !== null && _vm$category2 !== void 0 && _vm$category2.code) ? _c('div', {
    staticClass: "mb-30px mb-md-40px"
  }, [((_vm$category3 = _vm.category) === null || _vm$category3 === void 0 ? void 0 : _vm$category3.code) === 'department' || !((_vm$category4 = _vm.category) !== null && _vm$category4 !== void 0 && _vm$category4.code) ? _c('v-btn-toggle', {
    staticClass: "d-flex"
  }, [_c('v-flex', {
    staticClass: "v-btn px-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "color": _vm.mode == 'mobile' ? 'primary' : 'white',
      "x-large": "",
      "tile": "",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'mobile';
      }
    }
  }, [_vm._v("모바일")])], 1), _c('v-flex', {
    staticClass: "v-btn px-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "color": _vm.mode == 'paper' ? 'primary' : 'white',
      "x-large": "",
      "tile": "",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'paper';
      }
    }
  }, [_vm._v("지류")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _c('giftcard-list', {
    attrs: {
      "category": _vm.category,
      "mode": _vm.mode
    }
  })], 1)])])], 1)], 1), !((_vm$me = _vm.me) !== null && _vm$me !== void 0 && _vm$me.ci) ? _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "width": _vm.$vuetify.breakpoint ? '50%' : '90%',
      "scrollable": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('a', {
    attrs: {
      "href": "/mypage/profile"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/gshoppopup2.jpg"
    }
  })], 1), _c('div', {
    staticClass: "popup-layer-foot",
    staticStyle: {
      "display": "flex",
      "background-color": "#424242",
      "padding": "10px"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    },
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])], 1)])], 1) : _vm._e(), _c('popup-layer', {
    attrs: {
      "code": "gshop"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }